<div style="display: contents;">
  <div class="text-container">
    <ng-content></ng-content>
  </div>
  <div class="img-container">
    <img [src]="img" alt="masthead-basic-updated-image" />
  </div>
</div>